// src/utils/theme.ts
import color from "color"; // 需先安装：npm install color -S

/**
 * 动态设置 Element Plus 主题色
 * @param primaryColor 主色值（如 #27ba9b）
 */
export function setThemeColor(primaryColor, callback) {
  // 1. 获取根节点
  const root = document.documentElement;

  // 2. 生成主色的深浅变体（保证 hover/active 等状态颜色协调）
  const primary = color(primaryColor);
  const light3 = primary.lighten(0.3).hex(); // 浅3度
  const light5 = primary.lighten(0.5).hex(); // 浅5度
  const light7 = primary.lighten(0.7).hex(); // 浅7度
  const light8 = primary.lighten(0.8).hex(); // 浅8度
  const light9 = primary.lighten(0.9).hex(); // 浅9度
  const dark2 = primary.darken(0.2).hex(); // 深2度

  // 3. 动态设置 CSS 变量（覆盖 Element Plus 内置变量）
  root.style.setProperty("--el-color-primary", primaryColor);
  root.style.setProperty("--el-color-primary-light-3", light3);
  root.style.setProperty("--el-color-primary-light-5", light5);
  root.style.setProperty("--el-color-primary-light-7", light7);
  root.style.setProperty("--el-color-primary-light-8", light8);
  root.style.setProperty("--el-color-primary-light-9", light9);
  root.style.setProperty("--el-color-primary-dark-2", dark2);

  const fontColor = getFrontColor(primaryColor);

  root.style.setProperty("--el-color-font", fontColor);
  // 可选：保存主题色到本地存储，刷新后恢复
  localStorage.setItem("primary-theme-color", primaryColor);
  localStorage.setItem("primary-font-color", fontColor);
  callback(fontColor);
}

//设置字体颜色
export function setFontColor(primaryColor) {
  // 1. 获取根节点
  const root = document.documentElement;
  root.style.setProperty("--el-color-font", primaryColor);
}

/**
 * 初始化主题色（页面加载时恢复上次设置的主题）
 */
export function initThemeColor() {
  let savedColor = localStorage.getItem("primary-theme-color");
  if (!savedColor) {
    // savedColor = "#057748";
    savedColor = "#1d8179";
  }
  setThemeColor(savedColor, () => {});
}

/**
 * 根据背景色生成前景色
 * @param {*} bgColor 背景色
 * @returns 如果背景色为暗色，则前景色为白色，反之根据背景色调整亮度
 */
function getFrontColor(bgColor) {
  try {
    const data = color(bgColor);
    if (data.isLight()) {
      return data.darken(0.5).hex();
    } else {
      return "#fff";
    }
  } catch (e) {
    return "#fff"; // 出错返回白色
  }
}
